// extracted by css-extract-rspack-plugin
export default {"list":"list-CBVb0i","listIsEmpty":"listIsEmpty-wBNE_V"};